/**
 * Nexus Flow Routing
 *
 * Shared helpers for safe continuation paths across Nexus journeys.
 *
 * Primary responsibilities:
 * - Validate internal continuation paths from query params
 * - Provide consistent labels for setup flow "back" actions
 *
 * Dependencies:
 * - None
 */

export function getSafeInternalPath(path: string | null | undefined): string | null {
  if (!path) return null

  const trimmedPath = path.trim()
  if (!trimmedPath) return null
  if (!trimmedPath.startsWith('/')) return null
  if (trimmedPath.startsWith('//')) return null

  return trimmedPath
}

export function getSafeInternalPathOrFallback(
  path: string | null | undefined,
  fallbackPath: string
): string {
  return getSafeInternalPath(path) || fallbackPath
}

export function getSetupReturnLabel(returnTo: string | null): string {
  if (!returnTo) return 'Back to previous step'
  if (returnTo.includes('/nexus/conversations')) return 'Run First Conversation'
  if (returnTo.includes('/nexus/integrations')) return 'Back to Integrations'
  if (returnTo.includes('/nexus/agents/new')) return 'Back to Agent Setup'
  if (returnTo.includes('/nexus/agents/')) return 'Back to Agent'
  if (returnTo.includes('/nexus/templates')) return 'Back to Templates'
  if (returnTo.includes('/nexus/onboarding')) return 'Back to Onboarding'

  return 'Back to previous step'
}
